class LoadStage {
    constructor(text, size, callback) {
        this.text = text;
        this.size = size;
        this.callback = callback;
    }

    execute(finish, error, update) {
        this.callback(finish, error, update);
    }
}

export default class Loader {
    constructor(update) {
        this._stages = [];
        this.totalSize = 0;

        this._executeIndex = 0;

        this._onSuccess = null;
        this._onError = null;

        this.lastStageProgress = 0;
        this.progress = 0;

        this._onUpdate = update;
    }

    addStage(text, size, stageCallback) {
        const newStage = new LoadStage(text, size, stageCallback);
        this.totalSize += newStage.size;
        this._stages.push(newStage);
    }

    mergeLoader(loader) {
        for (let i = 0; i < loader._stages.length; i++) {
            this._stages.push(loader._stages[i]);
        }
        this.totalSize += loader.totalSize;
    }

    execute(success, error) {
        this._onSuccess = success;
        this._onError = error;
        this.step();
    }

    step() {
        if (this._executeIndex < this._stages.length) {
            const stage = this._stages[this._executeIndex];
            stage.execute(
                () => {
                    this.lastStageProgress += stage.size;
                    this._onUpdate(this.lastStageProgress / this.totalSize, stage.text);
                    window.setTimeout(() => {
                        this.step();
                    }, 1);
                },
                err => {
                    const errorObj = {
                        error: err,
                        stage,
                        progress: this.progress
                    };
                    this.handleError(errorObj);
                },
                progress => {
                    this.progress = this.lastStageProgress + progress;
                    if (this._onUpdate) this._onUpdate(this.progress / this.totalSize, stage.text);
                }
            );
            this._executeIndex++;
        } else if (this._onSuccess) {
            this._onSuccess();
        }
    }

    handleError(err) {
        if (this._onError) {
            this._onError(err);
        }
        console.error(err);
    }
}
